const ErrorHandler: any = (error: Error, info: { componentStack: string }) => {
  console.error(error, info);
};

export default ErrorHandler;
